<template>
  <div class="Search">
    <van-search v-model="value"
                show-action
                placeholder="请输入搜索关键词"
                @search="onSearch"
                @cancel="onCancel" />

  </div>
</template>


<script>
import { Toast } from 'vant';
export default {
  name: 'Head',
  props: {
  },
  data () {
    return {

    }
  },
  methods: {
    onSearch (val) {
      Toast(val);
    },
    onCancel () {
      Toast('取消');
    },
  },
}
</script>

<style lang="scss" scope>
.blank {
  height: 120px;
}
.nav {
  position: fixed;
  background-color: #fff;
  z-index: 999;
  top: 0;
  width: 100%;
  left: 0;
  box-shadow: 0px 0px 8px rgba($color: #000000, $alpha: 0.2);
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
  }
}
.logobox {
  height: 80px;
  img {
    display: block;
    height: 100%;
  }
}
.rightBtn {
  display: flex;
}
.btn-lis {
  height: 60px;
  margin-left: 30px;
  img {
    display: block;
    height: 100%;
  }
}
.van-popup {
  .van-popup__close-icon {
    font-size: 50px;
  }
  .menu-nav {
    text-align: left;
    width: 400px;
    height: 100%;
    background-color: #fff;
    .title {
      padding: 30px;
      font-size: 36px;
    }
    .erLis {
      display: block;
      padding: 20px 0;
      color: #545454;
    }
  }
}
</style>